// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-img {
  --v-theme-overlay-multiplier: 3;
  z-index: 0;
}
:where(.vuetify-styles) .v-img.v-img--absolute {
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}
:where(.vuetify-styles) .v-img.v-img--fit-content {
  max-width: fit-content;
}
:where(.vuetify-styles) .v-img.v-img--fit-content > .v-img__img {
  position: relative;
}
:where(.vuetify-styles) .v-img.v-img--fit-content > .v-responsive__sizer {
  display: none;
}
:where(.vuetify-styles) .v-img--booting .v-responsive__sizer {
  transition: none;
}
:where(.vuetify-styles) .v-img--rounded {
  border-radius: 4px;
}

:where(.vuetify-styles) .v-img__img,
:where(.vuetify-styles) .v-img__picture,
:where(.vuetify-styles) .v-img__gradient,
:where(.vuetify-styles) .v-img__placeholder,
:where(.vuetify-styles) .v-img__error {
  z-index: -1;
}
:where(.vuetify-styles) .v-img__img,
:where(.vuetify-styles) .v-img__picture,
:where(.vuetify-styles) .v-img__gradient,
:where(.vuetify-styles) .v-img__placeholder,
:where(.vuetify-styles) .v-img__error {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

:where(.vuetify-styles) .v-img__img--preload {
  filter: blur(4px);
}
:where(.vuetify-styles) .v-img__img--contain {
  object-fit: contain;
}
:where(.vuetify-styles) .v-img__img--cover {
  object-fit: cover;
}

:where(.vuetify-styles) .v-img__gradient {
  background-repeat: no-repeat;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VImg/VImg.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,UAAU;AACZ;AACA;EACE,YAAY;EACZ,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,WAAW;AACb;AACA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B","sourcesContent":[".v-img {\n  --v-theme-overlay-multiplier: 3;\n  z-index: 0;\n}\n.v-img.v-img--absolute {\n  height: 100%;\n  left: 0;\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  z-index: -1;\n}\n.v-img.v-img--fit-content {\n  max-width: fit-content;\n}\n.v-img.v-img--fit-content > .v-img__img {\n  position: relative;\n}\n.v-img.v-img--fit-content > .v-responsive__sizer {\n  display: none;\n}\n.v-img--booting .v-responsive__sizer {\n  transition: none;\n}\n.v-img--rounded {\n  border-radius: 4px;\n}\n\n.v-img__img,\n.v-img__picture,\n.v-img__gradient,\n.v-img__placeholder,\n.v-img__error {\n  z-index: -1;\n}\n.v-img__img,\n.v-img__picture,\n.v-img__gradient,\n.v-img__placeholder,\n.v-img__error {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.v-img__img--preload {\n  filter: blur(4px);\n}\n.v-img__img--contain {\n  object-fit: contain;\n}\n.v-img__img--cover {\n  object-fit: cover;\n}\n\n.v-img__gradient {\n  background-repeat: no-repeat;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
